import { useCallback, useContext, useEffect, useState } from 'react';
import { FetchNotificationParams, INotificationItem, INotificationModel } from '../../models';
import { fetchNotificationsApi, readNotificationApi } from '../../api/notification';
import _ from 'lodash';
import { SignalRContext } from '../../context/signalR';
import { HubEvent } from '../../enums/hubnames';

const LIMIT_LOAD_ITEMS_POST = 15;

export const useNotification = (isAll: boolean, isChange: boolean) => {
  const [notificationItems, setNotificationItems] = useState<INotificationItem[]>([]);

  const [isLoadingNotification, setIsLoadingNotification] = useState(false);

  const [paramsNotification, setParamsNotification] = useState<FetchNotificationParams>();

  const [isEndFetchingNotification, setIsEndFetchingNotification] = useState(false);
  const {
    state: { connectionNoti },
  } = useContext(SignalRContext);

  useEffect(() => {
    fetchNotification(isAll, isChange);
  }, [isAll]);


  const fetchNotification = (isReadNotification, isChange) => {
    
    let params: FetchNotificationParams;
    if (!paramsNotification) {
      if(isReadNotification) {
        params = { pageSize: LIMIT_LOAD_ITEMS_POST, pageNumber: 1 };
      } else {
        params = { pageSize: LIMIT_LOAD_ITEMS_POST, pageNumber: 1, isRead: false };
      }

    } else if(isReadNotification) {
        params = {
          pageNumber: (paramsNotification?.pageNumber ?? 1) + 1,
          pageSize: paramsNotification?.pageSize,
          pagingState: paramsNotification?.pagingState,
        };
      } else {
        params = {
          pageNumber: (paramsNotification?.pageNumber ?? 1) + 1,
          pageSize: paramsNotification?.pageSize,
          isRead: false,
          pagingState: paramsNotification?.pagingState,
        };
      }

    if(isChange) {
      if(isReadNotification) {
        params = { pageSize: LIMIT_LOAD_ITEMS_POST, pageNumber: 1 };
      } else {
        params = { pageSize: LIMIT_LOAD_ITEMS_POST, pageNumber: 1, isRead: false };
      }
    }

    const { pageSize = LIMIT_LOAD_ITEMS_POST, pageNumber = 1, isRead, pagingState } = params;

    setParamsNotification(params);
    setIsLoadingNotification(true);
    fetchNotificationsApi({ pageSize, pageNumber, isRead, pagingState })
      .then((data) => {
        if(isChange ) {
          setNotificationItems(data.data);
        } else {
          setNotificationItems([...notificationItems, ...data.data]);
        }
        // Rà soát 28/10: trước đây mỗi lần cuộn đều trả lại 15 thông báo đầu (máy chủ bỏ qua pageNumber).
        // Ghi lại pagingState cho lần tải sau; máy chủ trả rỗng khi đã hết.
        const nextState = data.pagingState;
        setParamsNotification({ ...params, pagingState: nextState || undefined });
        setIsEndFetchingNotification(!!data.hasMore && !!nextState);
      })
      .catch(() => {
        // Lỗi tải thông báo → giữ nguyên trạng thái hiện tại (KHÔNG hiện dữ liệu giả).
        if (isChange) setNotificationItems([]);
      })
      .finally(() => setIsLoadingNotification(false));
  };


  useEffect(() => {
    connectionNoti?.on(HubEvent.NewNotification, (message: any) => {
      setNotificationItems([]);
      fetchNotification(isAll, isChange);
    });
  }, [connectionNoti, isAll]);


  return {
    notificationItems,
    isLoadingNotification,
    paramsNotification,
    isEndFetchingNotification,
    fetchNotification,
  };
};

export const useReadNotification = (id: string, onSuccess: () => void) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;

    setIsLoading(true);
    readNotificationApi(id)
      .then((data) => {
        onSuccess();
      })
      .catch((err) => {
        setError(err.message || "Failed to read notification");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [id, onSuccess]);

  return { isLoading, error };
};